import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductConfigurator from '../Components/ProductConfigurator';
import { load, increment, decrement, changeVariant } from '../Actions/ProductConfigurator.action';
import { catchError } from '../Actions/Error.action';
import { receive, loadError } from '../Actions/Cart.action';
import withReactiveStyleBuyButtonInverted from './withReactiveStyleBuyButtonInverted';
import { addMultiple as addToCartService } from '../Services/Cart.service';

class ProductConfiguratorContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.load(this.props.baseProduct);
    }

    render() {
        return <ProductConfigurator {...this.props}
            onClick={(articles, currency) => this.props.onClick({ articles, currency })} />
    };
}

const mapStateToProps = state => {
    const { articles, emptyArticles } = state;
    return {
        ...articles, ...emptyArticles,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: (baseProduct) => dispatch(load(baseProduct)),
        increment: (articleId) => dispatch(increment(articleId)),
        decrement: (articleId) => dispatch(decrement(articleId)),
        changeVariant: (oldId, newId) => dispatch(changeVariant(oldId, newId)),
        onSuccess: (cart) => dispatch(receive(cart)),
        onError: (ex) => dispatch(catchError(ex, error => loadError(error)))
    }
}

export const onClick = ({ articles, currency }) => {

    var soldOut = false;
    articles.forEach(article => {
        var selected = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];
        if (selected != undefined && selected.soldOut) {
            soldOut = true;
        }
    });
    if (soldOut) {
        return undefined;
    }

    var variantsSelected = articles.filter(article => article.defaultAmmount > 0);

    var variantsToAddToCart =
        variantsSelected
            .map(article => {
                return {
                    articleNumber: article.defaultVariant,
                    quantity: article.defaultAmmount,
                    price: article.configVariants.filter(x => x.sku == article.defaultVariant)[0].price,
                }
            });
    return addToCartService({ articles: variantsToAddToCart, currency });
}

export default connect(mapStateToProps, mapDispatchToProps)(withReactiveStyleBuyButtonInverted(ProductConfiguratorContainer, onClick, 'buy-button-container'))